module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


// WEBPACK FOOTER //
// ./node_modules/jszip/node_modules/core-js/library/modules/_property-desc.js